import React, { ReactNode } from 'react';

import classNames from 'classnames';

import ArrowDownIcon from '../icons/arrow-down-icon.svg';
import ArrowUpIcon from '../icons/arrow-up-icon.svg';

import './ui-select-heading.scss';

interface UiSelectHeadingProps {
  title: string | ReactNode;
  isOpened: boolean;
  sm?: boolean;
  lg?: boolean;
  focused?: boolean;
  completed?: boolean;
  label?: string;
  additionalInfo?: React.ReactNode;
}

const UiSelectHeading: React.FC<UiSelectHeadingProps> = ({
  title,
  label,
  focused,
  completed,
  isOpened,
  sm,
  lg,
  additionalInfo,
}) => (
  <div
    className={classNames('ui-select-heading', {
      'ui-select-heading--sm': sm,
      'ui-select-heading--lg': lg,
      'ui-select-heading--focused': focused,
      'ui-select-heading--completed': completed,
    })}
  >
    {label && (
      <div
        className={classNames('ui-select-heading__label', {
          'ui-select-heading__label--lg': lg && completed,
        })}
      >
        {label}
      </div>
    )}
    <span>{title}</span>
    {additionalInfo ? (
      additionalInfo
    ) : (
      <img src={isOpened ? ArrowUpIcon : ArrowDownIcon} alt="" />
    )}
  </div>
);

export default UiSelectHeading;
